module.exports = __webpack_public_path__ + "img/interac-online.275b7a26.svg";